module.exports = __webpack_public_path__ + "img/logo.a54908aa.png";